import { createContext, useContext } from 'react';

import { IEmployee } from '@entities/employee/model/types';
import { IMyTeamContext, TModal } from '@widgets/MyTeam/model/types';

export const MyTeamContext = createContext<IMyTeamContext | null>({
    currentModal: null,
    currentClickedId: null,
    onCloseCurrentModal: () => null,
    onChangeCurrentClickedId: (clickedId: IEmployee['id']) => {},
    onChangeCurrentModal: (modal: TModal) => {},
});
export const useMyTeamContext = () => {
    const context = useContext(MyTeamContext);
    if (!context) throw new Error('useMyTeamContext must be used within MyTeamProvider');

    return context;
};
